/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_Ai_DescInputs */

const en_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Prompts and responses from resume tailoring, interview preparation, and cover letter generation — Legal basis: Contract performance (Art. 6(1)(b) GDPR)`)
};

const de_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Eingaben und Antworten aus Lebenslauf-Anpassung, Vorstellungsgespraechs-Vorbereitung und Anschreiben-Generierung — Rechtsgrundlage: Vertragserfuellung (Art. 6 Abs. 1 lit. b DSGVO)`)
};

const fr_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Requêtes et réponses de l'adaptation de CV, la préparation d'entretien et la génération de lettres de motivation`)
};

const es_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Solicitudes y respuestas de la adaptación de currículum, preparación de entrevista y generación de cartas de presentación`)
};

const it_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Prompt e risposte dalla personalizzazione del curriculum, preparazione al colloquio e generazione della lettera di presentazione`)
};

const nl_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Prompts en antwoorden van CV-aanpassing, sollicitatiegespreksvoorbereiding en motivatiebriefgeneratie`)
};

const pl_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Zapytania i odpowiedzi z dostosowywania CV, przygotowania do rozmowy kwalifikacyjnej i generowania listów motywacyjnych`)
};

const fi_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Kehotukset ja vastaukset ansioluettelon räätälöinnistä, haastatteluun valmistautumisesta ja saatekirjeen luonnista`)
};

const da_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Prompter og svar fra CV-tilpasning, interviewforberedelse og ansøgningsbrevsgenerering`)
};

const sv_privacy_data_processing_item_ai_desc = /** @type {(inputs: Privacy_Data_Processing_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` Prompter och svar från CV-anpassning, intervjuförberedelse och generering av personliga brev`)
};

/**
* | output |
* | --- |
* | "Prompts and responses from resume tailoring, interview preparation, and cover letter generation — Legal basis: Contract performance (Art. 6(1)(b) GDPR)" |
*
* @param {Privacy_Data_Processing_Item_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_ai_desc = /** @type {((inputs?: Privacy_Data_Processing_Item_Ai_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_Ai_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "es") return es_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "it") return it_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "da") return da_privacy_data_processing_item_ai_desc(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_ai_desc(inputs)
	return en_privacy_data_processing_item_ai_desc(inputs)
});